import React from "react"
import propTypes from "prop-types"

class Radio extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedOption: ""
    }
  }

  componentDidMount() {
    const { defaultValue } = this.props

    this.setState({ selectedOption: defaultValue })
  }

  componentDidUpdate(prevProps) {
    const { defaultValue } = this.props

    if (prevProps.defaultValue !== defaultValue) {
      this.setDefaultValue()
    }
  }

  setDefaultValue = () => {
    const { defaultValue } = this.props

    this.setState({ selectedOption: defaultValue })
  }

  handleOnChange = e => {
    const { onChange, field } = this.props

    this.setState({ selectedOption: e.currentTarget.value })

    onChange(field.name, "value", e.currentTarget.value)
  }

  render() {
    const { selectedOption } = this.state
    const { field, className, isSubmitted } = this.props

    return (
      <div
        className={`form_radio ${className}${
          isSubmitted && !!field.message && field.required ? " is-invalid" : ""
        }`}
      >
        <div className="row">
          {field.options.map((item, index) => {
            const key = `${field.name}_${index}`

            return (
              <div key={key} className={`col ${item.className}`}>
                <label htmlFor={key}>
                  <input
                    id={key}
                    type="radio"
                    value={item.value}
                    name={field.name}
                    onChange={this.handleOnChange}
                    checked={selectedOption === item.value}
                  />
                  <div
                    className={[
                      "form_radio_item",
                      selectedOption === item.value
                        ? "form_radio_item--active"
                        : ""
                    ].join(" ")}
                  >
                    <div className="form_radio_item_text">{item.text}</div>
                  </div>
                </label>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

Radio.propTypes = {
  field: propTypes.shape({
    name: propTypes.string.isRequired,
    message: propTypes.string.isRequired,
    required: propTypes.bool.isRequired,
    options: propTypes.arrayOf(
      propTypes.shape({
        text: propTypes.string.isRequired,
        value: propTypes.string,
        className: propTypes.string
      })
    ).isRequired
  }).isRequired,
  defaultValue: propTypes.oneOfType([propTypes.string, propTypes.number]),
  isSubmitted: propTypes.bool.isRequired,
  onChange: propTypes.func.isRequired,
  className: propTypes.string
}

Radio.defaultProps = {
  defaultValue: "",
  className: ""
}

export default Radio
